import { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { fmtDay } from "@/lib/daytime";

export function DaytimeWaitlist() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => { api.get("/daytime/admin/waitlist").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e))); }, []);
  useEffect(() => { load(); }, [load]);
  const offer = async (id) => { try { await api.post(`/daytime/admin/waitlist/${id}/offer`); toast.success("Family notified — available to book"); load(); } catch (e) { toast.error(apiErr(e)); } };
  return (
    <div className="space-y-2 mt-3" data-testid="dt-waitlist">
      <p className="text-xs text-slate-500">When a space opens, the first waiting family is moved to AVAILABLE TO BOOK and notified automatically. Nobody is charged until they book.</p>
      {rows.length === 0 && <p className="text-sm text-slate-400">Nobody on the waitlist.</p>}
      {rows.map((w) => (
        <div key={w.id} className="bg-white border border-slate-200 rounded-2xl p-3 flex flex-wrap justify-between items-center gap-2" data-testid={`dt-wait-${w.id}`}>
          <div><p className="font-bold text-navy">{fmtDay(w.date)} · {w.name}</p>
            <p className="text-xs text-slate-500">{w.explorers.join(", ") || "Explorer not chosen"} · {w.phone} · {w.email}</p></div>
          {w.status === "offered" ? <span className="text-xs font-bold text-emerald-600">AVAILABLE TO BOOK (notified)</span>
            : <Button size="sm" className="rounded-full bg-turquoise text-navy" onClick={() => offer(w.id)} data-testid={`dt-offer-${w.id}`}>Offer space</Button>}
        </div>
      ))}
    </div>
  );
}
